import { render, staticRenderFns } from "./contactIntegral.vue?vue&type=template&id=8b8caf52&scoped=true"
import script from "./contactIntegral.vue?vue&type=script&lang=js"
export * from "./contactIntegral.vue?vue&type=script&lang=js"
import style0 from "./contactIntegral.vue?vue&type=style&index=0&id=8b8caf52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8caf52",
  null
  
)

export default component.exports